import { api } from "api/api";
import { AxiosError } from "axios";
import AprovacaoFaixaValoresRotina from "model/administracao/cadastro/aprovacaofaixavalores/AprovacaoFaixaValoresRotina";
import NivelAprovacao from "model/administracao/cadastro/nivelaprovacao/NivelAprovacao";
import Page from "model/page/Page";
import Pageable from "model/page/Pageable";
import { DataTableFilterMeta } from "primereact/datatable";
import { BaseServiceCadastros } from "service/BaseServiceCadastros";
import { generateKey } from "utils/generateKey";

class AprovacaoFaixaValoresService implements BaseServiceCadastros<AprovacaoFaixaValoresRotina> {

    pesquisar(page: Pageable, filters?: DataTableFilterMeta | null) {
        return new Promise<Page>((resolve, reject): void => {
            const data = [new AprovacaoFaixaValoresRotina(0, 'VIAGEM', 'Viagem')];
            resolve(new Page(data, 1));
        });
    }

    consultar(tipoRotina: string) {
        return new Promise<AprovacaoFaixaValoresRotina>((resolve, reject): void => {
            api
                .get(`/aprovacaofaixavalores/consultar/${tipoRotina}`)
                .then(response => {
                    const aprovacao: AprovacaoFaixaValoresRotina = response.data;
                    aprovacao.aprovacoes.forEach(item => {
                        item.key = generateKey();
                        return item;
                    });
                    resolve(aprovacao);
                })
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    incluir(nivelAprovacao: AprovacaoFaixaValoresRotina) {
        return new Promise<AprovacaoFaixaValoresRotina>((resolve, reject): void => {

        });
    }

    editar(aprovacaofaixavalores: AprovacaoFaixaValoresRotina) {
        return new Promise<AprovacaoFaixaValoresRotina>((resolve, reject): void => {
            api
                .put(`/aprovacaofaixavalores/editar`, JSON.stringify(aprovacaofaixavalores))
                .then(response => {
                    const aprovacao: AprovacaoFaixaValoresRotina = response.data;
                    aprovacao.codigo = aprovacao.tipoRotina;
                    resolve(aprovacao);
                })
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    excluir(id: number) {
        return new Promise<void>((resolve, reject): void => {
        });
    }

    niveis() {
        return new Promise<NivelAprovacao[]>((resolve, reject): void => {
            api
                .get(`/aprovacaofaixavalores/niveis`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

}

export default AprovacaoFaixaValoresService;
